import React, { Component, ErrorInfo, ReactNode } from "react"

interface Props {
  children: ReactNode
  fallback: ReactNode | ((props: { error: Error; retry: () => void }) => ReactNode)
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(err: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: err }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      const err = this.state.error!
      if (typeof this.props.fallback === "function") {
        return this.props.fallback({ error: err, retry: () => this.setState({ hasError: false, error: undefined }) })
      }
      return this.props.fallback
    }

    return this.props.children
  }
}
